import * as Yup from 'yup'

export const employment = Yup.object({
    job_title:Yup.string().required('INPUT.VALIDATION.JOBPOST.JOB.TITLE'),
    company_name:Yup.string().required('INPUT.VALIDATION.COMPANY.NAME'),
    company_location:Yup.string().required('INPUT.VALIDATION.EMPLOYMENT.COMPANY.LOCATION'),
    working_since_start:Yup.mixed().required('INPUT.VALIDATION.SINCEWHEN'),
    working_since_end:Yup.string().nullable(),

})
